import { MaterialType } from "../../carrier/carrier-enum";
import { LabMDM } from '../models/lab';
import { ChemicalCategory } from "./chemicalCategory-enum";

//this model is used to deinf e the lab properites
export class Chemical {

    _id: string;
  
    /** The Name of a Chemical. */
    name:string;

	/** The location business area combination. */
    hazardousType :string ;
    
    /** The location. */
    lab:LabMDM ;
	
	/** The countryName of a lab. */
    barcode:string;

    /** The countryCode of a lab. */   
    originalVolume:number;
	
	/** The timezone. */
    remainingVolume:number ;

    /** describes if the lab is activated or not. */
    active:boolean;

    type: MaterialType;

    category: ChemicalCategory;
}